import logo from "../assets/logo/logo.webp"

export const EventixData = {
    brand: {
        name: "Eventix",
        tagline: "We Plan - We Create - You Celebrate",
        description: "Eventix is an event planning and management platform. Focused on India and Nepal, we handle everything from planning to execution so you can celebrate stress-free.",
        logo: logo,
        established: 2026,
    },
    contact: {
        email: "info@eventix.com",
        supportEmail: "support@eventix.in",
        phone: "+918595457520",
        whatsapp: "+918595457520",
        address: "Kolkata • West Bengal • India",
    },
    socials: {
        facebook: "https://facebook.com/eventix",
        instagram: "https://www.instagram.com/eventix.ig/",
        linkedin: "https://linkedin.com/company/eventix",
        youtube: "https://www.youtube.com/@eventix.in-yt",
    },
    officeHours: [
        { day: "Mon - Fri", time: "9:00 AM - 8:00 PM", highlight: false },
        { day: "Sat", time: "10:00 AM - 4:00 PM", highlight: false },
        { day: "Sunday", time: "By Appointment", highlight: true }
    ],
};